"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createAssigner = _interopRequireDefault(require("./_createAssigner.js"));
var _keys = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
var _default = exports.default = (0, _createAssigner.default)(_keys.default);